import * as React from "react";
import { useMappedState } from "redux-react-hook";

import { IProduct } from "src/core/products/api/products.api";
import { IDrop } from "src/core/drops/api/drops.api";
import { IStore } from "src/core/shared/store";
import { IProductSubstitution } from "src/modules/substitutions/api/substitutions.api";

import { ProductCardWithSubstitution } from "./ProductCardWithSubstitution";
import { StandardProductCard } from "./StandardProductCard";
import { CompactProductCard } from "./CompactProductCard";
import { useProductIsAllowedSubs } from "../../hooks/useProductIsAllowedSubs";

export interface IProductCardProps {
  productImage?: string;
  product: IProduct;
  substitution?: IProductSubstitution;
  className?: string;
  drop: IDrop | null;
  view: "grid" | "compact";
}

export const ProductCard: React.ReactFCWithChildren<IProductCardProps> = ({
  product,
  substitution,
  productImage,
  className,
  view
}) => {
  const { currentRole, installedModules } = useMappedState(({ global }: IStore) => ({
    currentRole: global.role,
    installedModules: global.settings ? global.settings.installedModules : []
  }));

  const allowedSubs = useProductIsAllowedSubs(product);

  return ((substitution && allowedSubs) ? (
    <ProductCardWithSubstitution
      product={product}
      substitution={substitution}
      productImage={productImage}
      className={className}
      currentRole={currentRole}
      installedModules={installedModules}
      view={view}
    />
  ) : view === "grid" ? (
    <StandardProductCard
      product={product}
      productImage={productImage}
      className={className}
      currentRole={currentRole}
      installedModules={installedModules}
      unavailable={!allowedSubs && substitution ? substitution.message : null}
    />
  ) : (
    <CompactProductCard
      product={product}
      productImage={productImage}
      className={className}
      currentRole={currentRole}
      installedModules={installedModules}
      unavailable={!allowedSubs && substitution ? substitution.message : null}
    />
  ));
};

export { SelectedProductCard } from "./SelectedProductCard";
